import React from 'react';
import { PopupContext } from 'ui-builder';
import ChatHeader from './Components/ChatHeader';
import MessageList from './Components/MessageList';
import MessageInput from './Components/MessageInput';
import { useResizable } from './useResizable';
import { useAutoContext } from '../useAutoContext';
import styles from './ChatWidget.module.scss';

interface ChatWidgetLayoutProps {
  onClose: () => void;
  onExpand: (conversationId: number | null) => void;
}

export default function ChatWidgetLayoutWeb(props: ChatWidgetLayoutProps) {
  useAutoContext();

  const { height, handleRef, panelRef } = useResizable({
    minHeight: 300,
    maxHeightVh: 95,
    initialHeightRem: 50,
  });

  return (
    <PopupContext>
      <div
        className={styles.panel}
        ref={panelRef}
        style={{ height }}
        data-testid="chat-widget"
      >
        <div className={styles.resizeHandle} ref={handleRef} />
        <ChatHeader onClose={props.onClose} onExpand={props.onExpand} />
        <MessageList />
        <MessageInput />
      </div>
    </PopupContext>
  );
}
